<template>
  <div>
    <div
      class="absolute bg-gray-100 dark:bg-gray-950/50 w-full"
      :style="{
        top: '0px',
        height: startTime * minuteSize + 'px'
      }"
    />
    <div
      class="absolute bg-gray-100 dark:bg-gray-950/50 w-full"
      :style="{
        top: finishTime * minuteSize + 'px',
        height: (1440 - finishTime) * minuteSize + 'px'
        // top: finishTime * minuteSize + 'px',
        // height: (1395 - finishTime) * minuteSize + 'px'
      }"
    />
  </div>
</template>

<script setup lang="ts">
const { $auth } = useNuxtApp()

interface Props {
  section: any
}

const props = defineProps<Props>()

const startTime = computed(() => props.section.roster?.hour?.startTime || 0)
const finishTime = computed(() => props.section.roster?.hour?.finishTime || 0)
const minuteSize = computed(() => {
  const value = Number($auth?.info?.minuteSize)
  return Number.isFinite(value) && value > 0 ? value : 2
})
</script>
